<template>
    <div>
        <Form inline>
            <FormItem label="ERP SKU" :label-width="70">
                <Select
                    style="width: 180px"
                    clearable
                    filterable
                    v-model="formData.CN_sku"
                    ref="zierpselect"
                    remote
                    :remote-method="remoteMethod1"
                    :loading="loading1"
                >
                    <Option
                        v-for="item in erpSkusList"
                        :value="item.name"
                        :key="item.id"
                        >{{ item.name }}</Option
                    >
                </Select>
            </FormItem>
            <FormItem
                :label="$t('tms.ship.warehouse', { defaultValue: '仓库' })"
                :label-width="90"
            >
                <div>
                    <Select
                        clearable
                        v-model="formData.EQ_orgWarehouseId"
                        filterable
                    >
                        <Option
                            v-for="item in getNewWarehouseIdList"
                            :value="item.value"
                            :key="item.value"
                            >{{ item.label }}
                        </Option>
                    </Select>
                </div>
            </FormItem>

            <FormItem :label-width="1">
                <Button
                    type="primary"
                    @click="getVsGroupRule"
                    icon="ios-search"
                    >{{
                        $t("tms.ship.search_for", { defaultValue: "搜索" })
                    }}</Button
                >
                <Button @click="reset" icon="md-refresh">{{
                    $t("tms.ship.reset", { defaultValue: "重置" })
                }}</Button>
            </FormItem>
        </Form>
        <Table
            :columns="columns"
            :data="data"
            @on-selection-change="handleChecked"
            stripe
            border
            :loading="loading"
        ></Table>
        <compSpage
            class="text-right margin-top-10"
            v-bind="{ total, pageSize: formData.rows, current: formData.page }"
            @on-update="updateList"
        ></compSpage>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import compSpage from "@/components/boss/spage";
import { HttpFindByPage } from "@/service/boss/b2corder";
import { HttpVsSkuList } from "@/service/boss/allot";
export default {
    props: ["virtalertsearch", "searcherpsku"],
    components: {
        compSpage,
    },
    data() {
        return {
            formData: {
                page: 1,
                rows: 10,
                CN_sku: "",
                EQ_orgWarehouseId: "",
                EQ_inventoryType: 0,
            },
            checkedId: [],
            erpSkusList: [],
            title: "",
            rowId: "",
            data: [],
            total: 0,
            loading: false,
            loading1: false,
        };
    },
    computed: {
        // ...mapState('boss',['products']),
        // ...mapGetters('boss',['warehouses']),
        ...mapGetters("diction", ["getNewWarehouseIdList"]),
        columns() {
            return [
                {
                    type: "selection",
                    width: 60,
                },
                {
                    title: "ERP SKU",
                    key: "erpSku",
                },
                {
                    title: this.$t("tms.ship.warehouse", {
                        defaultValue: "仓库",
                    }),
                    key: "orgWarehouseCode",
                },
                {
                    title: this.$t("erp.b2c.available_stock", {
                        defaultValue: "可用库存",
                    }),
                    width: 100,
                    key: "inventoryAvailable",
                },
                {
                    title: this.$t("erp.b2c.product_name", {
                        defaultValue: "产品名称",
                    }),
                    width: 250,
                    key: "title",
                },
            ];
        },
    },
    watch: {
        virtalertsearch: function () {
            // console.log(this.virtalertsearch)
            if (this.virtalertsearch == true) {
                this.getProductList();
                this.getVsGroupRule();
            }
        },
    },
    methods: {
        handleChecked(selection, row) {
            this.checkedId = selection.map((item) => {
                return item.id;
            });
        },
        getRowData() {
            let arr = [];
            this.data.map((item) => {
                this.checkedId.map((json) => {
                    if (json == item.id) {
                        arr.push(item);
                    }
                });
            });
            return arr;
        },
        reset() {
            this.formData = {
                page: 1,
                rows: 10,
                CN_sku: "",
                EQ_orgWarehouseId: "",
                EQ_inventoryType: 0,
            };
            this.getProductList();
            this.getVsGroupRule("reset");
            this.$emit("on-reset");
        },
        getProductList() {
            this.$refs.zierpselect.clearSingleSelect();
            // this.formData.CN_sku = ''
            HttpVsSkuList({ page: 1, rows: 10 }).then((res) => {
                // console.log(res)
                this.erpSkusList = res.data.content.map((item) => {
                    return { name: item.erpSku, id: item.id };
                });
            });
        },
        remoteMethod1(query) {
            HttpVsSkuList({
                page: 1,
                rows: 100,
                "search[CN_erpSku]": query,
            }).then((res) => {
                // console.log(res)
                this.erpSkusList = res.data.content.map((item) => {
                    return { name: item.erpSku, id: item.id };
                });
            });
        },
        async getVsGroupRule(type) {
            this.loading = true;
            let data;
            if (type == "reset") {
                data = this.formData.CN_sku;
            } else {
                if (this.virtalertsearch == true) {
                    data = this.formData.CN_sku;
                }
            }
            const response = await HttpFindByPage({
                page: 1,
                rows: 10,
                search: {
                    EQ_inventoryType: this.formData.EQ_inventoryType,
                    EQ_orgWarehouseId: this.formData.EQ_orgWarehouseId,
                    CN_sku: data,
                },
            });
            if (response) {
                this.loading = false;
                this.total = response.data.totalElements || 0;
                this.handleList(response.data.content);
            }
        },
        async updateList(data) {
            this.loading = true;
            this.formData = Object.assign({}, this.formData, data);
            const response = await HttpFindByPage({
                page: this.formData.page,
                rows: this.formData.rows,
                search: {
                    EQ_inventoryType: this.formData.EQ_inventoryType,
                    EQ_orgWarehouseId: this.formData.EQ_orgWarehouseId,
                    CN_sku: this.formData.CN_sku,
                },
            }).catch((res) => {
                this.loading = false;
                this.$Message.error(res.message);
            });
            if (response) {
                this.loading = false;
                this.handleList(response.data.content);
                this.total = response.data.totalElements || 0;
            }
        },
        handleList(content) {
            let aaa = content.map((item) => {
                return {
                    id: item.id,
                    erpSku: item.sku,
                    productId: item.productId,
                    title: item.product ? item.product.name : "",
                    orgWarehouseCode: item.orgWarehouseCode,
                    inventoryAvailable: item.inventoryAvailable,
                    quantity: 1,
                };
            });
            this.data = aaa;
        },
    },
};
</script>
